import localePt from "@angular/common/locales/pt";
import { Component, Input, LOCALE_ID } from "@angular/core";
import { Store, Select } from "@ngxs/store";
import { Observable } from "rxjs";
import {
  CartAddOrUpdate,
  ProductCart} from "../../../../../core/cart/model/cart-model";
import { CartState } from "../../../../../core/cart/state/cart.state";
import {
  AddToCart,
  RemoveFromCart,
  RemoveItemFromCart,
  ToggleSidebarCart} from "../../../../../core/cart/state/cart.action";
import { CommonModule, registerLocaleData } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { AddCheckingOut } from "src/app/core/account/state/account.action";
import { trigger, transition, style, animate } from '@angular/animations';
import { DsButtonComponent } from "src/app/ui/design-system/button/button.component";

registerLocaleData(localePt, "pt-BR");

const materialModules = [MatIconModule, MatBadgeModule];

@Component({
  standalone: true,
  selector: "app-header-cart",
  templateUrl: "./cart.component.html",
  styleUrls: ["./cart.component.scss"],
  imports: [DsButtonComponent, CommonModule, TranslateModule, RouterModule, ...materialModules],
  providers: [{ provide: LOCALE_ID, useValue: "pt-BR" }],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-in', style({ transform: 'translateX(0%)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ transform: 'translateX(100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class CartComponent {
  @Select(CartState.cartItems) cartItem$: Observable<ProductCart[]>;
  @Select(CartState.cartTotal) cartTotal$: Observable<number>;
  @Select(CartState.sidebarCartOpen) sidebarCartOpen$: Observable<boolean>;

  @Input() style: string = "basic";

  public cartStyle: string = "cart_sidebar";
  public shippingFreeAmt: number = 0;
  public cartTotal: number = 0;
  public shippingCal: number = 0;
  public confettiItems = Array.from({ length: 150 }, (_, index) => index);
  public confetti: number = 0;
  public loader: boolean = false;
  public showSuccessFeedback: boolean = false;

  constructor(private store: Store) {}

  cartToggle(value: boolean) {
    this.store.dispatch(new ToggleSidebarCart(value));
  }

  checkout() {
    this.store.dispatch(new AddCheckingOut(true));
    this.cartToggle(false);
  }

  addQuantity(product: ProductCart) {
    const params: CartAddOrUpdate = {
      productId: product.productId,
      imageUrl: product.imageUrl,
      name: product.name,
      color: product.color,
      size: product.size,
      price: product.price,
      discountPrice: product.discountPrice,
      quantity: 1,
      showSideBar: true};
    this.store.dispatch(new AddToCart(params));
    this.triggerSuccessFeedback();
  }

  removeQuantity(product: ProductCart) {
    const params: CartAddOrUpdate = {
      productId: product.productId,
      imageUrl: product.imageUrl,
      name: product.name,
      color: product.color,
      size: product.size,
      price: product.price,
      discountPrice: product.discountPrice,
      quantity: product.quantity,
      showSideBar: true};
    this.store.dispatch(new RemoveFromCart(params));
  }

  removeItemFromCart(product: ProductCart) {
    const params = {
      productId: product.productId,
      color: product.color,
      size: product.size};
    this.store.dispatch(new RemoveItemFromCart(params));
  }

  // Método para ativar feedback de sucesso
  triggerSuccessFeedback() {
    this.showSuccessFeedback = true;
    setTimeout(() => {
      this.showSuccessFeedback = false;
    }, 600);
  }
}
